import { render, staticRenderFns } from "./TournamentPrintModal.vue?vue&type=template&id=c60d3ba4&scoped=true&"
import script from "./TournamentPrintModal.vue?vue&type=script&lang=js&"
export * from "./TournamentPrintModal.vue?vue&type=script&lang=js&"
import style0 from "./TournamentPrintModal.vue?vue&type=style&index=0&id=c60d3ba4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60d3ba4",
  null
  
)

export default component.exports